export const JOB_STATUSES = [
  { value: "new", label: "New" },
  { value: "scheduled", label: "Scheduled" },
  { value: "in_progress", label: "In progress" },
  { value: "completed", label: "Completed" },
  { value: "invoiced", label: "Invoiced" },
  { value: "paid", label: "Paid" },
  { value: "cancelled", label: "Cancelled" },
];

export const INVOICE_STATUSES = [
  { value: "pending", label: "Pending" },
  { value: "sent", label: "Sent" },
  { value: "paid", label: "Paid" },
  { value: "overdue", label: "Overdue" },
];

export const PAYMENT_TYPES = [
  { value: "insurance", label: "Insurance claim" },
  { value: "cash", label: "Cash / Private" },
];

export const DUPLICATE_REASONS = [
  "Re-fitment / rework on same vehicle",
  "Different glass (side / rear / other)",
  "Additional damage discovered",
  "Previous booking cancelled / rescheduled",
  "Customer request — separate job, same vehicle",
  "Fleet vehicle — multiple repairs scheduled",
  "Data correction (replacing earlier booking)",
  "Other (see notes)",
];

export const COMPANY = {
  name: "Diesel And Dust Group (Pty) Ltd",
  tradingAs: "Diesel & Dust Windscreens",
  tagline: "Auto Glass Specialists & Fitment Centre",
  regNumber: "2016/153695/07",
  vatNumber: "4570285421",
  address: "13 Claredon Rd, Brenthurst, Brakpan, 1540",
  email: "dieselendust@gmail.com",
  phone: "081 506 9375",
  bank: "Capitec Business",
  accountHolder: "Diesel And Dust Group Pty Ltd",
  accountNumber: "1051263557",
  branch: "450105",
  accountType: "Business Current",
};

export const statusColor = (s) => {
  switch (s) {
    case "new": return "bg-[#9aa6ad] text-white";
    case "scheduled": return "bg-[#ffc438] text-black";
    case "in_progress": return "bg-[#3b82f6] text-white";
    case "completed": return "bg-[#10b981] text-white";
    case "invoiced": return "bg-[#f28a16] text-white";
    case "paid": return "bg-[#065f46] text-white";
    case "cancelled": return "bg-[#6b6b6b] text-white";
    default: return "bg-[#cfd7db] text-[#111619]";
  }
};
